<template>
  <gg-card>
    <gg-card-header>
      Add New Addon Domain
    </gg-card-header>
    <gg-card-text>
      <v-alert dense dark color="primary">
        <template v-slot:prepend>
          <v-icon size="28" color="white" class="mr-3">mdi-information-outline</v-icon>
        </template>
        An addon domain is an additional domain that the system stores as a subdomain of your main site. Use addon
        domains to host additional domains on your account.
      </v-alert>

      <form>
        <gg-text-field label="New Domain Name"
                       name="New Domain Name"
                       v-model="addonData.newdomain"
                       v-validate="{ excluded: hostingDomainsList, required: true }"
                       :error-messages="errors.collect('New Domain Name')"
                       @change="autocomplete"
        />

        <gg-btn dark color="green"
                class="ml-0"
                type="submit"
                tile
                :loading="loading"
                @click.prevent="addDomain">Add Domain
        </gg-btn>
      </form>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CreateAddonDomainForm',
  components: {
  },
  data () {
    return {
      loading: false,
      addonData: {
        newdomain: '',
        subdomain: '',
      },
    }
  },
  computed: {
    ...mapGetters(['hostingDomainsList']),
  },
  methods: {
    ...mapActions({
      addHostingAddonDomain: 'hostingDomains/addHostingAddonDomain',
      reportError: 'reportError',
      reportSuccess: 'reportSuccess',
    }),
    async autocomplete () {
      const isValid = await this.$validator.validate('New Domain Name')

      if (!isValid) {
        this.reset(false)
      } else {
        // apply new values
        const [ subdomain ] = this.addonData.newdomain.split('.')
        this.addonData.subdomain = subdomain
      }
    },
    reset (resetValidator = true) {
      this.addonData.newdomain = ''
      this.addonData.subdomain = ''
      if (resetValidator) {
        this.$nextTick(() => { this.$validator.reset() })
      }
    },
    async addDomain () {
      const mainFormValid = await this.$validator.validateAll()
      // check validity
      if (!mainFormValid) {
        return
      }
      try {
        this.loading = true
        let msg = ''
        const response = await this.addHostingAddonDomain({ ...this.addonData, _username: this.$route.query.user })

        if (response.error === undefined) {
          msg += `The addon domain “${this.addonData.newdomain}” has been created.`
          this.reportSuccess(msg)
          this.$emit('addondomain-created')
          this.reset()
        } else {
          this.reportError(response.error)
        }
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    }
  },
}
</script>
